export const API_TRACKING_GOAL = '/Analytics/TriggerGoal';

export const API_TRACKING_GOAL_EMAIL = '/Analytics/TriggerGoalWithEmail';